import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { SubSink } from "subsink";

import { PageService, ConfigurationService } from "@/shared-module/services";
import { DownloadService } from "@/core/services";
import { Configuration } from "@/shared-module/models";

@Component({ templateUrl: "documents.component.html" })
export class DocumentsComponent implements OnInit, OnDestroy {
  title: string;
  subtitle: string;
  configuration: Configuration;
  nextDecision: Date;
  path: string;
  subpath: string;
  subs = new SubSink();
  documentsData: any;

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    private downloadService: DownloadService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    const thisObject = this;

    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.configuration = c;
        this.configurationService.redirectIfDisabled();
      },
    );

    const combine = combineLatest(
      this.route.params,
      this.route.queryParams,
    ).pipe(switchMap((results) => this.getObservable()));
    this.subs.sink = combine.subscribe((s: any) => this.loadPageContent(s));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  loadPageContent(s: any) {
    this.title = s.title;
    this.subtitle = s.subTitle;
    this.nextDecision = s.nextDecision;
    this.documentsData = s.zones[0].dataSource;
  }

  documentOpened(documentId) {
    this.downloadService.downloadFile(documentId);
  }

  getObservable() {
    let path: string;
    let subpath: string;
    if (this.route.snapshot.paramMap.has("path")) {
      path = this.route.snapshot.paramMap.get("path");
    }
    if (this.route.snapshot.paramMap.has("subpath")) {
      subpath = this.route.snapshot.paramMap.get("subpath");
    }
    const regionParam = this.route.snapshot.queryParams;
    return this.pageService.getpath("documents", path, subpath, regionParam);
  }
}
